import { get } from '@rails/request.js';

import FormController from '@controllers/portal/components/form_controller';

export default class extends FormController {
  dropdownBlur(e) {
    const dropdown = e.detail.dropdown;

    if (dropdown.initializing || !e.detail.wasChanged) return;

    if (dropdown.id === 'option-set-dropdown') {
      const selection = dropdown.getSelection() || '';
      get(`${dropdown.streamValue}&option_set_id=${selection.value}`, {
        contentType: 'application/json',
        responseKind: 'turbo-stream',
      })
    }
  }
}
